<script setup>
import { ref } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import ReportHeader from './components/ReportHeader.vue';
import SummaryReports from './components/SummaryReports.vue';
import AgentDetailedReportModal from './components/AgentDetailedReportModal.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';

const summarReportsRef = ref(null);
const store = useStore();
const { t } = useI18n();
const showDetailedReportModal = ref(false);

const onDownloadClick = () => {
  summarReportsRef.value.downloadReports();
};

const onDetailedReportClick = () => {
  showDetailedReportModal.value = true;
};

const onDetailedReportConfirm = async ({ agent, from, to }) => {
  try {
    if (!agent || !agent.id) {
      useAlert(t('AGENT_REPORTS.DETAILED_REPORT_MODAL.EXPORT_ERROR'));
      return;
    }

    await store.dispatch('downloadAgentDetailedLoginReport', {
      userId: agent.id,
      from,
      to,
    });
    showDetailedReportModal.value = false;
    useAlert(t('AGENT_REPORTS.DETAILED_REPORT_MODAL.EXPORT_SUCCESS'));
  } catch (error) {
    console.error('Error downloading detailed report:', error);
    const errorMessage =
      error?.message ||
      error?.response?.data?.error ||
      t('AGENT_REPORTS.DETAILED_REPORT_MODAL.EXPORT_ERROR');
    useAlert(errorMessage);
  }
};

const onDetailedReportClose = () => {
  showDetailedReportModal.value = false;
};
</script>

<template>
  <ReportHeader
    :header-title="$t('AGENT_REPORTS.HEADER')"
    :header-description="$t('AGENT_REPORTS.DESCRIPTION')"
  >
    <div class="flex gap-2">
      <V4Button
        :label="$t('AGENT_REPORTS.DOWNLOAD_AGENT_REPORTS')"
        icon="i-ph-download-simple"
        size="sm"
        @click="onDownloadClick"
      />
      <V4Button
        :label="$t('AGENT_REPORTS.DOWNLOAD_DETAILED_REPORT')"
        icon="i-ph-file-csv"
        size="sm"
        variant="faded"
        @click="onDetailedReportClick"
      />
    </div>
  </ReportHeader>

  <SummaryReports
    ref="summarReportsRef"
    action-key="summaryReports/fetchAgentSummaryReports"
    getter-key="agents/getAgents"
    fetch-items-key="agents/get"
    summary-key="summaryReports/getAgentSummaryReports"
    type="agent"
  />

  <AgentDetailedReportModal
    :show="showDetailedReportModal"
    @confirm="onDetailedReportConfirm"
    @close="onDetailedReportClose"
  />
</template>
